import React from 'react';
import { Range } from '../../../../domain/FilterTypes';
import {
  propertyTaxesOptions
} from '../../../../domain/filterOptions';
import { RangeInput } from '../../common/RangeInput';
import { formatPropertyTaxesValue } from '../../../../domain/mappers/propertyTaxesMapper';

interface CostFinanceBodyProps {
  propertyTaxes: Range;
  pricePerSqft: Range;
  acceptedFinancing: string;
  onPropertyTaxesChange: (type: 'min' | 'max', value: string) => void;
  onPricePerSqftChange: (type: 'min' | 'max', value: string) => void;
  onAcceptedFinancingChange: (value: string) => void;
}

// const acceptedFinancingOptions = [
//   'Select one',
//   'Cash',
//   'Conventional',
//   'FHA',
//   'VA',
//   'USDA',
//   'Any'
// ];

export const CostFinanceBody = ({
  propertyTaxes,
  pricePerSqft,
  acceptedFinancing,
  onPropertyTaxesChange,
  onPricePerSqftChange,
  onAcceptedFinancingChange,
}: CostFinanceBodyProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {/* Property taxes - now a range */}
      <RangeInput
        label="Property taxes"
        minValue={formatPropertyTaxesValue(propertyTaxes.min, true)}
        maxValue={formatPropertyTaxesValue(propertyTaxes.max, false)}
        minOptions={propertyTaxesOptions}
        maxOptions={propertyTaxesOptions}
        onMinChange={(value) => onPropertyTaxesChange('min', value)}
        onMaxChange={(value) => onPropertyTaxesChange('max', value)}
      />

      {/* Accepted financing */}
      {/* <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">Accepted financing</label>
        <select
          value={acceptedFinancing}
          onChange={(e) => onAcceptedFinancingChange(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
        >
          {acceptedFinancingOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div> */}
    </div>
  );
};
